import React, { useRef } from 'react';
import { Form, Button, Badge, Card } from 'react-bootstrap';

const FileUploadDemo = ({
    label,
    name,
    accept = ".pdf,.jpg,.jpeg,.png,.dxf",
    file,
    onChange,
    required = false,
    multiple = false
}) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const selectedFiles = multiple ? Array.from(e.target.files) : e.target.files[0];
        onChange(name, selectedFiles);
    };

    const handleRemove = () => {
        onChange(name, multiple ? [] : null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const renderFileName = () => {
        if (!file) return null;

        if (multiple && Array.isArray(file)) {
            return file.map((f, idx) => (
                <Badge key={idx} bg="success" className="me-2 mb-2">
                    📄 {f.name}
                </Badge>
            ));
        }

        return (
            <Badge bg="success" className="me-2">
                📄 {file.name}
            </Badge>
        );
    };

    return (
        <Form.Group className="mb-3">
            <Form.Label>
                {label}
            </Form.Label>

            <div className="d-flex align-items-center gap-2">
                <Form.Control
                    ref={fileInputRef}
                    type="file"
                    accept={accept}
                    onChange={handleFileChange}
                    multiple={multiple}
                    style={{ maxWidth: '400px' }}
                />
                {file && (
                    <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={handleRemove}
                    >
                        ✕ Eliminar
                    </Button>
                )}
            </div>

            {file && (
                <div className="mt-2">
                    {renderFileName()}
                </div>
            )}

            <Form.Text className="text-muted">
                {accept === ".pdf,.jpg,.jpeg,.png,.dxf"
                    ? "Formatos aceptados: PDF, JPG, PNG, DXF"
                    : `Formatos aceptados: ${accept.replace(/\./g, '').toUpperCase()}`}
            </Form.Text>
        </Form.Group>
    );
};

export default FileUploadDemo;
